module.exports = __webpack_public_path__ + "static/media/ls.bc85c1bf.svg";